import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { LicenseInfo } from '@mui/x-license';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';

// MUI X Pro licence — Lumeros Energy. Expires 2026-11-26.
// MUI keys are intended to be present in the client bundle; validation is
// server-side against the deploy domain. Move to REACT_APP_MUI_LICENSE_KEY
// env var once we have per-environment configs.
LicenseInfo.setLicenseKey(
  process.env.REACT_APP_MUI_LICENSE_KEY ||
  'c7efa854370201b26c50d70a5807606dTz0xMjIyNzEsRT0xNzk1NzM3NTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI='
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
